<template>
  <div @scroll="test" style="height: 100vh; overflow: auto">
    <van-nav-bar
      :title="active == '0' ? '直播列表' : 'BIM资料'"
      left-text="返回"
      left-arrow
      @click-left="onClickLefted"
    />
    <van-row class="bg-white">
      <van-col :span="22" :offset="1" v-if="images.length > 0">
        <Swipe :images="images" />
      </van-col>
    </van-row>
    <van-tabs
      v-model="active"
      sticky
      @disabled="onClickDisabled"
      style="padding-bottom: 40px"
    >
      <van-tab title="免费直播">
        <Live :liveList="liveClass.liveList" :classList="liveClass.classList" />
      </van-tab>
      <van-tab title="BIM资料">
        <BIMData />
      </van-tab>
    </van-tabs>
    <Footer :footerType="footerType"></Footer>
  </div>
</template>

<script>
import Swipe from "@/components/liveList/swipe";
import Live from "@/components/liveList/live";
import BIMData from "@/components/liveList/BIMData";
import Footer from "@/components/footer";

// import { getLiveBroadcastList } from "@/model/live/serve";
export default {
  components: { Swipe, Live, BIMData, Footer },
  data() {
    return {
      images: [], // 存放轮播图
      active: "0",
      liveClass: {
        liveList: [], // 存放直播列表
        classList: [], // 存放课程列表
      },
      scrollTop: 0,
      footerType: true,
    };
  },
  created() {
    let query = this.$route.query;
    if (query.open) {
      if (localStorage.getItem("setToken") == null) {
        // false  没有登录   true  登录
        this.goLogin();
      } else {
        this.Api({
          url:
            this.getBelong() == null
              ? "api/live/gotoLiveBroadcast?liveId=" +
                query.LiveId +
                "&uid=" +
                localStorage.getItem("uid") +
                "&deviceId=" +
                this.getSession("ip") + "&open=false"
              : "api/live/gotoLiveBroadcast?liveId=" +
                query.LiveId +
                "&belong=" +
                this.getBelong() +
                "&uid=" +
                localStorage.getItem("uid") +
                "&deviceId=" +
                this.getSession("ip") + "&open=false",
        })
          .then((res) => {
            this.$router.push({
              path: "/lookLive",
              query: { lookDress: res.data.studenturl },
            });
          })
          .catch((err) => {
            alert("打开直播间失败,请联系学习规划老师");
            console.log(JSON.stringify(err));
          });
      }
    }
    this.getLiveBroadcastList();
    this.$nextTick(() => {
      let BIMType = localStorage.getItem("BIMType");
      if (BIMType) {
        // 判断是否是从BIM资料中点击的登录 如果是 刷新后自动跳转到BIM资料界面
        this.active = 1;
        localStorage.setItem("BIMType", "false");
      }
    });
  },
  methods: {
    onClickDisabled(name, title) {
      alert(title + "功能暂未开放");
    },
    getLiveBroadcastList() {
      this.Api({
        url: "api/live/getLiveBroadcastList",
        method: "GET",
      }).then((res) => {
        let data = res.data;
        data.forEach((item) => {
          if (item.title == "广告图") {
            this.images = item.list;
          } else if (item.title == "今日") {
            if (item.live.length == 0) return false;
            item.live.forEach((live) => {
              live.today = true;
              this.liveClass.liveList.push(live);
            });
          } else if (item.title == "课程") {
            if (item.clist.length == 0) return false;
            item.clist.forEach((clist) => {
              this.liveClass.classList.push(clist);
            });
          } else if (item.title == "其他") {
            if (item.list.length == 0) return false;
            item.list.forEach((live) => {
              this.liveClass.liveList.push(live);
            });
          }
        });
      });
    },
    onClickLefted() {
      this.$router.push("/index");
    },
    test(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (
        scrollTop + clientHeight === scrollHeight ||
        scrollTop + clientHeight > scrollHeight
      ) {
        this.footerType = true;
      } else {
        let scroll = scrollTop - this.scrollTop;
        this.scrollTop = scrollTop;
        if (scroll < 0) {
          this.footerType = true;
        } else {
          this.footerType = false;
        }
      }
    },
  },
  computed: {
    goLiveNum() {
      return this.$store.state.Live.goLiveNum;
    },
  },
  watch: {
    goLiveNum: {
      immediate: true,
      deep: true,
      handler() {
        let query = this.$route.query;
        if (query.BIMData) {
          this.active = 1;
        } else {
          this.active = 0;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
</style>
